import { SharedMessage } from './share-storage';

export function updateShopifyMarket(market: string): void {
  const form = document.querySelector('form.shopify-localization-form');
  if (!(form instanceof HTMLFormElement)) {
    return;
  }

  const countryCode = form.querySelector('input[name=country_code]');

  if (!(countryCode instanceof HTMLInputElement)) {
    return;
  }

  countryCode.value = market.replace(/^\w\w-/, '');
  form.submit();
}

export function setLocaleCallback(message: SharedMessage): void {
  if (message.event !== 'setLocale') {
    return;
  }

  const { locale } = message.data;

  const currentLocale = `en-${window.Shopify.country === 'GB' ? 'gb' : 'us'}`;

  if (currentLocale === locale) {
    return;
  }

  updateShopifyMarket(locale);
}
